import * as React from 'react'

import { formatNamedPersonFullName } from '../person.helpers'

import type { INamedPerson } from '../person.interface'

interface Props {
  className?: string
  namedPerson: INamedPerson
}

const PersonName = function ({ className, namedPerson }: Props) {
  const value = React.useMemo(() => {
    const formattedName = formatNamedPersonFullName(namedPerson)
    return formattedName ? formattedName : '-'
  }, [namedPerson])
  return <span className={className}>{value}</span>
}

export default PersonName
